<template>
  <div>
    <ModalMapaFaenas
      :showModalMapa="showModalMapa"
      :propIdFaena="this.idFaenaSeleccionada"
      :seriesFaenas="seriesFaenas"
      @close="closeModal"
    >
    </ModalMapaFaenas>
    <div
      v-if="showPanelCalendario"
      style="z-index: 2000"
      class="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 transition-opacity"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <!-- Contenedor Modal -->
      <div
        class="relative bg-white w-full max-w-2xl mx-auto rounded-lg shadow-xl overflow-hidden"
      >
        <!-- Header -->
        <div class="bg-indigo-700 p-4">
          <div class="flex items-center justify-between">
            <div
              class="inline-flex h-10 w-10 items-center justify-center rounded-md text-white sm:h-12 sm:w-12"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-8 h-8"
                style="color: #fff"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                />
              </svg>
            </div>
            <h2 class="text-lg font-bold tracking-tight text-white sm:text-2xl">
              {{ $t("Calendario Historial") }}
            </h2>
            <button
              @click="loadPanelCalendario(false)"
              type="button"
              class="rounded-md bg-indigo-700 text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
            >
              <span class="sr-only">Cerrar modal</span>
              <svg
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
        <!-- Contenido -->
        <div class="m-0 p-7">
          <div
            class="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 m-0 p-0"
          >
            <div class="pl-[26%]">
              <month-picker
                @input="chgFec1"
                :default-year="defaultYear1"
                :default-month="defaultMonth1"
                :lang="selectedLang"
                :min-date="minDate1"
                :max-date="maxDate1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showPanelAyuda"
      style="z-index: 2000"
      class="relative z-10"
      aria-labelledby="slide-over-title"
      role="dialog"
      aria-modal="true"
    >
      <!-- Background backdrop, show/hide based on slide-over state. -->
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
      ></div>

      <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
          <div
            class="pointer-events-none fixed inset-y-0 right-0 flex pl-10 max-w-full"
          >
            <div class="pointer-events-auto w-screen max-w-4xl">
              <div
                class="flex h-full flex-col overflow-y-scroll bg-white shadow-xl"
              >
                <div class="bg-indigo-700 py-6 px-4 sm:px-6">
                  <div class="flex items-center justify-between">
                    <div
                      class="inline-flex h-10 w-10 items-center justify-center rounded-md text-white sm:h-12 sm:w-12"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-8 h-8"
                        style="color: #fff"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                        />
                      </svg>
                    </div>
                    <h2
                      class="text-1xl font-bold tracking-tight text-white sm:text-4xl"
                    >
                      {{ $t("informacion") }}
                    </h2>

                    <div class="ml-3 flex h-7 items-center">
                      <button
                        @click="loadPanelAyuda(false)"
                        type="button"
                        class="rounded-md bg-indigo-700 text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                      >
                        <span class="sr-only">Close panel</span>
                        <svg
                          class="h-6 w-6"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div class="mt-1"></div>
                </div>
                <div class="relative flex-1 py-6 px-2 sm:px-2">
                  <!-- Replace with your content -->
                  <div class="absolute inset-0 py-6 pt-8 sm:px-2">
                    <img
                      v-if="this.lang == 'es'"
                      src="../../assets/historial.png"
                    />
                    <img
                      v-else
                      src="../../assets/historial-ingles.png"
                      width="600"
                    />
                  </div>
                  <!-- /End replace -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showPanelExportarExcel"
      style="z-index: 2000"
      class="fixed inset-0 z-10 overflow-hidden"
      role="dialog"
      aria-modal="true"
    >
      <!-- Background backdrop -->
      <div class="absolute inset-0 bg-gray-500 bg-opacity-75"></div>

      <!-- Slide-over panel -->
      <div class="absolute inset-y-0 right-0 flex max-w-full pl-10">
        <div class="w-screen max-w-4xl bg-white shadow-xl overflow-y-scroll">
          <!-- Header -->
          <div
            class="bg-indigo-700 py-6 px-4 sm:px-6 flex items-center justify-between"
          >
            <div
              class="inline-flex h-10 w-10 items-center justify-center rounded-md bg-indigo-500 text-white sm:h-12 sm:w-12"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5"
                />
              </svg>
            </div>
            <h2
              class="text-1xl font-bold tracking-tight text-white sm:text-4xl"
            >
              {{ $t("Exportar datos a excel") }}
            </h2>

            <button
              @click="loadModalExportarExcel(false)"
              type="button"
              class="text-indigo-200 hover:text-white"
            >
              <svg
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
              <span class="sr-only">Close panel</span>
            </button>
          </div>

          <!-- Content -->
          <div class="flex-1 p-6">
            <h2 class="text-lg font-medium text-gray-900">
              {{ $t("Seleccione un rango de fechas") }}
            </h2>
            <div class="bg-white border-2 border-gray-200 mb-4">
              <CalendarioResumenExcel
                :fechasSeleccionadas="fechasMultiplesUnidades"
                @getFecCalendarExcel="getFecCalendarExcel"
              >
              </CalendarioResumenExcel>
            </div>

            <div class="flex justify-end space-x-4">
              <button
                @click="loadModalExportarExcel(false)"
                class="border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                {{ $t("Salir") }}
              </button>
              <button
                @click="exportarExcel()"
                class="bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                {{ $t("Exportar datos a excel") }}
              </button>
            </div>
            <div v-if="mostrarSpinnerExcel == true">
              <SpinnerLoading></SpinnerLoading>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showPanelExportar"
      style="z-index: 2000"
      class="fixed inset-0 z-10 overflow-hidden"
      role="dialog"
      aria-modal="true"
    >
      <!-- Background backdrop -->
      <div class="absolute inset-0 bg-gray-500 bg-opacity-75"></div>

      <!-- Panel -->
      <div class="absolute inset-y-0 right-0 flex max-w-full pl-10">
        <div class="w-screen max-w-4xl">
          <div class="flex h-full flex-col bg-white shadow-xl">
            <!-- Header -->
            <div
              class="bg-indigo-700 py-6 px-4 sm:px-6 flex items-center justify-between"
            >
              <div
                class="inline-flex h-10 w-10 items-center justify-center rounded-md bg-indigo-500 text-white"
              >
                PDF
              </div>
              <h2
                class="text-1xl font-bold tracking-tight text-white sm:text-4xl"
              >
                {{ $t("Generar reporte en PDF") }}
              </h2>
              <button
                @click="loadExportarPdf(false)"
                class="ml-3 text-indigo-200 hover:text-white focus:ring-2 focus:ring-white"
              >
                <svg
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="1.5"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <!-- Content -->
            <div class="relative flex-1 py-6 px-4 sm:px-6">
              <div class="grid gap-4">
                <div class="bg-gray-200 p-4">{{ $t("Mes") }}</div>
                <div class="flex justify-center">
                  <month-picker-input
                    :default-year="defaultYear1"
                    :default-month="defaultMonth1"
                    :lang="selectedLang"
                    :min-date="minDate1"
                    :max-date="maxDate1"
                  />
                </div>

                <!-- Footer buttons -->
                <div class="bg-gray-300 p-4 flex justify-end space-x-4">
                  <button
                    @click="loadExportarPdf(false)"
                    class="rounded-md border bg-white py-2 px-4 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:ring-2 focus:ring-indigo-500"
                  >
                    {{ $t("Salir") }}
                  </button>
                  <button
                    @click="descargaPdf()"
                    class="rounded-md bg-indigo-600 py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:ring-2 focus:ring-indigo-500"
                  >
                    {{ $t("Crear Pdf") }}
                  </button>
                </div>
                <div v-if="mostrarSpinner == true">
                  <SpinnerLoading></SpinnerLoading>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--- menu nuevo-->
    <div
      class="grid xs:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-1 p-4 pt-1"
    >
      <div class="container mx-auto pt-1 pb-0 pl-0 pr-0 items-left text-left">
        <span class="text-1xl text-white font-bold text-black">
          {{ $t("historial") }} {{ $t("centro") }} {{ nombreFaena }}
        </span>

        <div class="lg:flex mt-4">
          <div class="lg:w-1/3 pl-0 text-left">
            <h1 class="text-1xl font-extrabold text-left text-cyan-800">
              {{ this.titulo_fecha }}
            </h1>
          </div>

          <div class="lg:w-1/3 pl-0 text-left"></div>
          <div class="lg:w-1/3 pl-7 pr-5 text-center">
            <div
              class="grid sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-4 m-0 p-0"
            >
              <a
                href="#"
                class="-m-3 flex flex-col justify-between rounded-lg p-3 transition duration-150 ease-in-out hover:bg-gray-50"
              >
                <div
                  class="flex md:h-full lg:flex-col"
                  @click="loadPanelCalendario(true)"
                >
                  <div class="flex-shrink-0">
                    <div
                      class="inline-flex h-10 w-10 items-center justify-center rounded-md bg-indigo-500 text-white sm:h-12 sm:w-12"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-8 h-8"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M8 3v2m8-2v2M3 8h18M4.5 21h15a1.5 1.5 0 001.5-1.5v-11a1.5 1.5 0 00-1.5-1.5h-15a1.5 1.5 0 00-1.5 1.5v11a1.5 1.5 0 001.5 1.5z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div
                    class="ml-4 md:flex md:flex-1 md:flex-col md:justify-between lg:ml-0 lg:mt-4"
                  >
                    <div>
                      <p class="text-xs text-gray-900">
                        {{ $t("calendario") }}
                      </p>
                    </div>
                  </div>
                </div>
              </a>

              <a
                href="#"
                class="-m-3 flex flex-col justify-between rounded-lg p-3 transition duration-150 ease-in-out hover:bg-gray-50"
              >
                <div
                  class="flex md:h-full lg:flex-col"
                  @click="loadPanelAyuda(true)"
                >
                  <div class="flex-shrink-0">
                    <div
                      class="inline-flex h-10 w-10 items-center justify-center rounded-md bg-indigo-500 text-white sm:h-12 sm:w-12"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-8 h-8"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div
                    class="ml-4 md:flex md:flex-1 md:flex-col md:justify-between lg:ml-0 lg:mt-4"
                  >
                    <div>
                      <p class="text-xs text-gray-900">
                        {{ $t("informacion") }}
                      </p>
                    </div>
                  </div>
                </div>
              </a>

              <a
                href="#"
                class="-m-3 flex flex-col justify-between rounded-lg p-3 transition duration-150 ease-in-out hover:bg-gray-50"
              >
                <div
                  class="flex md:h-full lg:flex-col"
                  @click="loadModalExportarExcel(true)"
                >
                  <div class="flex-shrink-0">
                    <div
                      class="inline-flex h-10 w-10 items-center justify-center rounded-md bg-indigo-500 text-white sm:h-12 sm:w-12"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-8 h-8"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M15 10l-3-3m0 0l-3 3m3-3v12m9-4.5v6a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 19.5v-6"
                        />
                      </svg>
                    </div>
                  </div>

                  <div
                    class="ml-4 md:flex md:flex-1 md:flex-col md:justify-between lg:ml-0 lg:mt-4"
                  >
                    <div>
                      <p class="text-xs text-gray-900">{{ $t("Exportar") }}</p>
                    </div>
                  </div>
                </div>
              </a>

              <a
                href="#"
                class="-m-3 flex flex-col justify-between rounded-lg p-3 transition duration-150 ease-in-out hover:bg-gray-50"
              >
                <div
                  class="flex md:h-full lg:flex-col"
                  @click="loadExportarPdf(true)"
                >
                  <div class="flex-shrink-0">
                    <div
                      class="inline-flex h-10 w-10 items-center justify-center rounded-md bg-indigo-500 text-white sm:h-12 sm:w-12"
                    >
                      <span class="text-semibold">PDF</span>
                    </div>
                  </div>
                  <div
                    class="ml-4 md:flex md:flex-1 md:flex-col md:justify-between lg:ml-0 lg:mt-4"
                  >
                    <div>
                      <p class="text-xs text-gray-900">
                        {{ $t("Reporte Mensual") }}
                      </p>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="grid mt-2 pl-2 pr-2 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-2"
    >
      <div class="pb-6 bg-white rounded">
        <!-- consumo -->

        <ConsumoTrimestral
          :dataAcumulado="dataAcumulado"
          :dataCapMaxima="dataCapMaxima"
          :idFaena="idFaena"
          :aammConsulta="aammConsulta"
        ></ConsumoTrimestral>
      </div>
      <div class="pb-6 bg-white rounded">
        <DiarioAcumulado
          :idFaena="idFaena"
          :aammConsulta="aammConsulta"
          :diasMes="diasMes"
        >
        </DiarioAcumulado>
      </div>
    </div>

    <div class="mt-4 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1">
      <div class="lg:flex">
        <div class="lg:w-1/2 pl-5 text-left">
          <h1 class="text-1xl font-extrabold text-left text-cyan-800">
            {{ $t("Seleccione fechas de consulta") }}
          </h1>

          <CalendarioResumen
            :fechasSeleccionadas="fechasMultiplesUnidades"
            @getFecCalendar="getFecCalendar"
          >
          </CalendarioResumen>
        </div>

        <div class="lg:w-1/2 text-left pr-2"></div>
      </div>
    </div>

    <div class="grid xs:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 p-3">
      <textarea
        id="adjustable-textarea"
        row="100"
        class="w-full p-2 border border-gray-300 rounded text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 text-blue hidden"
        v-model="this.fs"
      >
      </textarea>
               <span class=" text-xs" style="color:#F9FAFB">
     noShowSetpoint:'{{ noShowSetpoint }}' this.vista:'{{ this.vista }}' granularidad:'{{ granularity }}' dias: '{{ dias }}' this.frecuencia_minutos:'{{ this.frecuencia_minutos }}' 
   </span>

      <GraficoMultiplesUnidadesDiaO2NaturalOxigenado
        @loadMapa="loadMapa"
        @loadMultiplesUnidades="loadMultiplesUnidades"
        :propIdFaena="idFaena"
        :seriesMedicionesOxigenado="seriesMedicionesOxigenado"
        :seriesMedicionesNatural="seriesMedicionesNatural"
        :mostrarSpinner="mostrarSpinner"
        :glosaDataTypeOxigenado="glosaDataTypeOxigenado"
        :glosaDataTypeNatural="glosaDataTypeNatural"
        nombreMedicion="Oxígeno Disuelto"
      >
      </GraficoMultiplesUnidadesDiaO2NaturalOxigenado>
    </div>

    <div class="grid xs:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 p-3">
      <GraficoMultiplesUnidadesDiaOrpNaturalOzonizado
        @loadMapa="loadMapa"
        @loadMultiplesUnidades="loadMultiplesUnidades"
        :propIdFaena="idFaena"
        :seriesMedicionesOrpOzonizado="seriesMedicionesOrpOzonizado"
        :seriesMedicionesOrpNatural="seriesMedicionesOrpNatural"
        :mostrarSpinner="mostrarSpinner"
        :glosaDataTypeOxigenado="glosaDataTypeOxigenado"
        :glosaDataTypeNatural="glosaDataTypeNatural"
      />
    </div>
  </div>
</template>

<style scoped>
.month-picker-wrapper {
  z-index: 10;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style>
<script>
import axios from "axios";
import { MonthPicker, MonthPickerInput } from "vue-month-picker";
import ExcelJS from "exceljs";
import { mapGetters } from "vuex";
import ConsumoTrimestral from "./ConsumoTrimestral";
//import GraficoMultiplesUnidadesDiaO2 from "./GraficoMultiplesUnidadesDiaO2";
import GraficoMultiplesUnidadesDiaO2NaturalOxigenado from "./GraficoMultiplesUnidadesDiaO2NaturalOxigenado";
import GraficoMultiplesUnidadesDiaOrpNaturalOzonizado from "./GraficoMultiplesUnidadesDiaOrpNaturalOzonizado";
import CalendarioResumen from "../calendar/CalendarioResumen";
import CalendarioResumenExcel from "../calendar/CalendarioResumenExcel";
import DiarioAcumulado from "./DiarioAcumulado";
import SpinnerLoading from "../SpinnerLoading";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ModalMapaFaenas from "../resumen/modal/ModalMapaFaenas";
import i18n from "@/i18n";
export default {
  components: {
    MonthPicker,
    MonthPickerInput,
    ConsumoTrimestral,
    DiarioAcumulado,
    // GraficoMultiplesUnidadesDiaO2,
    GraficoMultiplesUnidadesDiaO2NaturalOxigenado,
    GraficoMultiplesUnidadesDiaOrpNaturalOzonizado,
    CalendarioResumen,
    CalendarioResumenExcel,
    SpinnerLoading,
    ModalMapaFaenas,
  },
  props: [
    "idEmpresa",
    "nombreFaena",
    "idFaena",
    "idTipoMedicion",
    "nombreIdTipoMedicion",
    "tituloY",
    "propIdFaena",
  ],
  watch: {
    idFaena: function (value) {
      this.faena = value;
      this.mostrarSpinner = true;
      this.setFechasYSeries();
    },
  },
  mounted() {
    //console.log("id empresa:", this.empresa);
    //console.log("faena:", this.faena);
    //console.log("jaulas:", this.jaulas);
    //console.log("año:", this.defaultYear1);

    this.selectedLang = i18n.global.locale.value;

    let objFecha = this.$store.getters.fechaHoraActual(this.idFaena);
    const year = objFecha.getFullYear;
    const month = objFecha.getMonth;
    this.titulo_fecha =
      this.selectedLang == "en"
        ? this.nomMesEn[month] + " " + year
        : this.nomMes[month] + " " + year;
    this.defaultYear1 = year;
    this.defaultMonth1 = month;
    let m = month;
    m = m < 10 ? `0${m}` : `${m}`;
    this.aammConsulta = year + "-" + m;
    this.setFechasYSeries();

    this.lang = i18n.global.locale.value;
  },

  data() {
    return {
      nombreMedicionOrp: "",
      granularity: "",
      frecuencia_minutos:0,
      showModalMapa: false,
      glosaDataTypeOxigenado: "",
      glosaDataTypeNatural: "",
      glosaDataTypeO2Unidades: "",
      showPickMonth: true,
      dataAcumulado: [],
      dataCapMaxima: [],
      idO2Disuelto: 5,
      idO2Saturado: 6,
      idOrp: 4,
      mostrarSpinner: false,
      mostrarSpinnerO2: false,
      mostrarSpinnerExcel: false,
      diasMes: [],
      showPanelExportar: false,
      showPanelExportarExcel: false,
      showPanelCalendario: false,
      showPanelAyuda: false,
      selectedLang: "es",
      defaultYear1: "",
      defaultMonth1: "",
      minDate1: "",
      maxDate1: "",
      mmConsulta: "",
      aaConsulta: "",
      fInicial: "",
      fFinal: "",
      txt: "",
      fs: "",
      fs2: "",
      fechasBusqueda: [],
      empresa: this.idEmpresa,
      faena: this.idFaena,
      Centro2: [],
      dataLoaded: false,
      jaulas: [],
      seriesOrp: [],
      seriesOxigeno: [],
      seriesMedicionesOxigenado: [],
      chartOptions: {
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
            },
            enableMouseTracking: true,
          },
        },
        series: this.seriesFaenas,
        rangeSelector: {
          selected: 5,
          floating: true,
          y: 400,
        },
        title: {
          text: this.nombreIdTipoMedicion,
        },

        xAxis: {
          showLastLabel: true,
        },
        yAxis: {
          opposite: false,
          title: {
            text: this.tituloY,
          },
          formatter: function (val) {
            return val.toFixed(2);
          },
        },
      },
      nomMes: [
        "",
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      nomMesEn: [
        "",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      nomMesEng: [
        "",
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      fechaConsulta: [],
      aammConsulta: "",
      fechasSeleccionadas: [],
      fechasMultiplesUnidades: [],
      date: {
        from: null,
        to: null,
        month: null,
        year: null,
        monthIndex: null,
      },
      arrayDias: [],
      soloTest: [],
      startDateExcel: "",
      endDateExcel: "",
      unidadesInjeccion: [],
      seriesMedicionesOrpOzonizado: [],
      seriesMedicionesOrpNatural: [],
      //   from": "2023-01-01T03:00:00.000Z", "to": "2023-02-01T03:00:00.000Z", "month": "Enero", "monthIndex": 1, "year": 2023, "rangeFrom": null, "rangeTo": null, "rangeFromMonth": null, "rangeToMonth": null
      lang: "",
    };
  },
  methods: {
    async getUnitOxigenoDisuelto(
      startDate,
      endDate,
      parametroBuscado,
      es_faena_natural
    ) {
      let unidadesValue = [];
      try {
        const apiKey = this.$store.state.login.tokenLogin;
        const objStoreFaenas = this.$store.state.faenas;
        let arrayFaenas = [];
        this.objFaena = objStoreFaenas.faenas.filter(
          (faena) => faena.id == this.idFaena
        );
        arrayFaenas = this.objFaena;
        // todas las jaulas de la Faena
        let objFaena = arrayFaenas[0];
        let jaulas = objFaena.unidades.filter(
          (faena) => faena.natural == es_faena_natural
        );
        // Array de promesas para las solicitudes a axios
        // Si hay N elementos (jaulas) en el array jaulas, entonces se crearán N promesas en total,
        // una para cada elemento del array.

        const vista = "historial";
        this.frecuencia_minutos = this.$store.getters.diferenciaMinutos(
          startDate,
          endDate,
          this.propIdFaena
        );
        this.granularity = this.$store.getters.calculaPuntosGranularidad(
          this.frecuencia_minutos,
          vista
        );

        const jaulaPromises = jaulas.map((jaula) => {
          if (jaula.id !== undefined) {
            const requestData = {
              idUnit: jaula.id,
              tsi: `${startDate} 00:00:00`,
              tsf: `${endDate} 23:59:59`,
              granularity: this.granularity,
            };
            return axios
              .post("/api/mon/getUnitData", requestData, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `${apiKey}`,
                },
              })
              .then((response) => {
                let mediciones = [];
                let sensors = response.data.payload.sensors;

                sensors.forEach((sensor) => {
                  sensor.params.forEach((param) => {
                    if (param.id == parametroBuscado) {
                      let updatedData = param.values;

                      updatedData.forEach((valor) => {
                        if (typeof valor.ts === "string") {
                          let ts = valor.ts;
                          let dia = ts.substring(8, 10);
                          let indice_dia = !isNaN(Number(dia))
                            ? parseInt(dia) - 1
                            : 0;
                          mediciones.push({
                            dia: dia,
                            indice_dia: indice_dia,
                            value: valor.value,
                          });
                        }
                      });
                    }
                  });
                });
                unidadesValue.push({
                  idUnidad: jaula.id,
                  mediciones: mediciones,
                });
              })
              .catch((error) => {
                console.log("Error al obtener datos de la unidad", error);
                return [];
              });
          }
        });

        await Promise.allSettled(jaulaPromises);
        return unidadesValue;
      } catch (error) {
        console.log("error procesando faenas", error);
      }
    },
    async getUnitGasInjection(startDate, endDate, es_faena_natural) {
      let unidadesInjeccion = [];
      try {
        const apiKey = this.$store.state.login.tokenLogin;
        const objStoreFaenas = this.$store.state.faenas;
        let arrayFaenas = [];
        this.objFaena = objStoreFaenas.faenas.filter(
          (faena) => faena.id == this.idFaena
        );
        arrayFaenas = this.objFaena;
        // todas las jaulas de la Faena
        let objFaena = arrayFaenas[0];
        let jaulas = objFaena.unidades.filter(
          (faena) => faena.natural == es_faena_natural
        );
        // Array de promesas para las solicitudes a axios
        // Si hay N elementos (jaulas) en el array jaulas, entonces se crearán N promesas en total,
        // una para cada elemento del array.
        const jaulaPromises = jaulas.map((jaula) => {
          if (jaula.id !== undefined) {
            const requestData = {
              idUnit: jaula.id,
              startDay: `${startDate} 00:00:00`,
              finishDay: `${endDate} 23:59:59`,
            };
            return axios
              .post("/api/ctl/unitGasInjection", requestData, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `${apiKey}`,
                },
              })
              .then((response) => {
                this.glosaDataType =
                  response.data.payload.dataType == "dummy"
                    ? "Tipo de Datos: dummy"
                    : "";
                let gas = response.data.payload.gas;
                gas.forEach((g) => {
                  unidadesInjeccion.push({
                    idUnidad: jaula.id,
                    inyection: g.inyection,
                    glosaDataType: this.glosaDataType,
                  });
                });
              })
              .catch((error) => {
                console.log("Error al obtener datos de la unidad", error);
                return [];
              });
          }
        });

        await Promise.allSettled(jaulaPromises);
        return unidadesInjeccion;
      } catch (error) {
        console.log("error procesando faenas", error);
      }
    },
    setFechasYSeries() {
      // por defecto al montar componente  & watch : idFaena
      let objFecha = this.$store.getters.fechaHoraActual(this.idFaena);
      const aa = objFecha.getFullYear;
      const mm = objFecha.getMonth;

      this.diasMes = this.generaSerieDias(mm, aa);

      let mes_actual = mm;

      if (this.mmConsulta == "") {
        this.mmConsulta = mm;
      }
      mes_actual =
        this.mmConsulta.toString().length < 2
          ? `0${this.mmConsulta}`
          : this.mmConsulta;
      let aa_actual = aa;

      let fec1 = `01 ${mes_actual} ${aa_actual}`;
      let fec2 = `31 ${mes_actual} ${aa_actual}`;

      console.log("fechas seleccionadas", fec1, fec2);
      this.fechaConsulta = this.fechasSeleccionadas = [fec1, fec2];
      this.startDate = fec1;
      this.endDateExcel = fec2;
      this.aaConsulta = `${aa_actual}-${mes_actual}`;

      //this.getFecCalendar(this.fechasSeleccionadas);

      this.fechasMultiplesUnidades = this.calculaHoy7Dias();
    },
    calculaHoy7Dias() {
      let hoy = this.$store.getters.fechaHoraActual(this.idFaena);

      let diaHoy = String(hoy.getDate).padStart(2, "0");
      let mesHoy = String(hoy.getMonth).padStart(2, "0");
      let añoHoy = String(hoy.getFullYear).padStart(2, "0");
      let fechaHoy = `${diaHoy} ${mesHoy} ${añoHoy}`;

      let fec = this.$store.getters.restarDias(
        diaHoy,
        mesHoy,
        añoHoy,
        7,
        this.idFaena
      );
      let dd = String(fec.getDate).padStart(2, "0");
      let mm = String(fec.getMonth).padStart(2, "0");
      let aa = String(fec.getFullYear).padStart(2, "0");
      let fechaHace7Dias = `${dd} ${mm} ${aa}`;

      console.log("fechas", fechaHace7Dias, fechaHoy);

      return [fechaHace7Dias, fechaHoy];
    },

    chgFec1(date) {
      // al seleccionar mes en calendario MENSUAL

      let objFecha = this.$store.getters.fechaHoraActual(this.idFaena);

      if (parseInt(objFecha.getFullYear) < parseInt(date.year)) {
        return false;
      } else {
        if (parseInt(objFecha.getMonth) < parseInt(date.monthIndex))
          return false;
      }
      this.loadPanelCalendario(false);
      console.log(
        "fecs",
        parseInt(objFecha.getFullYear),
        parseInt(objFecha.getMonth),
        parseInt(date.monthIndex)
      );

      this.titulo_fecha = date.month + " " + date.year;
      this.loadAAMM(date.year + "-" + date.monthIndex);
      this.showDate(date);

      //this.$emit("loadAAMM",  date.year + "-" + date.monthIndex );
    },

    generaSerieDias(mm, aa) {
      let objFecha = this.$store.getters.fechaHoraActual(this.idFaena);
      let diaFinDeMes = 0;
      if (mm == objFecha.getMonth && aa == objFecha.getFullYear) {
        const day = objFecha.getDate;
        diaFinDeMes = day;
      } else {
        diaFinDeMes = this.$store.getters.ultimoDiaDelMes(
          mm,
          aa,
          this.idFaena
        ).getDate;
      }
      const arrayDias = [...Array(diaFinDeMes).keys()].map((i) => i + 1);
      console.log("diaFinDeMes", arrayDias);
      return arrayDias;
    },

    async showDate(date) {
      this.date = date;

      // construir fecha-formato compatible con  /api/mon/getConsolidatedData
      // El componente <month-picker-input> retorna: Marzo/ 2024
      console.log("error ", date.month.trim());
      this.mmConsulta =
        this.lang == "es"
          ? this.nomMes.indexOf(date.month.trim())
          : this.nomMesEn.indexOf(date.month.trim());
      console.log("error 0*", this.mmConsulta);
      this.aaConsulta = date.year;

      this.mmConsulta = String(this.mmConsulta).padStart(2, "0");

      console.log("error 1*", this.mmConsulta);
      this.aammConsulta = this.aaConsulta + "-" + this.mmConsulta;

      console.log("error**", this.mmConsulta, this.aaConsulta);

      // generar serie con dias del mes utilizado por componente HistorialDiario
      this.diasMes = this.generaSerieDias(this.mmConsulta, this.aaConsulta);
      this.fechasBusqueda = [this.fInicial, this.fFinal];

      // modificar prop   fechasSeleccionadas: ["01 08 2024", "31 08 2024"],
      let fec1 = `01 ${this.mmConsulta} ${this.aaConsulta}`;
      let fec2 =
        this.$store.getters.ultimoDiaDelMes(
          this.mmConsulta,
          this.aaConsulta,
          this.idFaena
        ).getDate + ` ${this.mmConsulta} ${this.aaConsulta}`;

      this.fechasSeleccionadas = [fec1, fec2];
      this.getFecCalendar(this.fechasSeleccionadas);
    },

    async descargaPdf() {
      this.mostrarSpinner = true;
      const logoBase64 =
        "data:image/png;base64,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"; // Aquí va la imagen en base64

      const doc = new jsPDF({
        format: "letter", // Tamaño de página "carta"
        unit: "pt", // Unidades en puntos
      });

      const columns = ["Dia", "Diario miligramos/litro", "Total Mes"];

      let filas = [];
      let acumulado = 0;
      for (let i = 0; i < this.diasMes.length; i++) {
        // añade un cero a la izquierda
        let mes =
          this.mmConsulta.toString().length < 2
            ? "0" + this.mmConsulta
            : this.mmConsulta;
        let dd =
          this.diasMes[i].toString().length < 2
            ? "0" + +this.diasMes[i]
            : +this.diasMes[i];

        let aaaammdd = this.aaConsulta + "-" + mes + "-" + dd;
        let medicion = this.oxigenado.find((med) => med.ts == aaaammdd);

        let valor = "";
        if (medicion) {
          valor = medicion.value;
        }
        acumulado += valor;
        acumulado = Math.floor(acumulado * 100) / 100; // truncar sin rendondear

        filas.push([dd + "/" + mes, valor, acumulado]);
      }
      const rows = filas;

      const addHeaderAndFooter = (doc, pageNumber, totalPages) => {
        doc.addImage(logoBase64, "JPEG", 40, 20, 100, 49);
        // Añadir título junto a la imagen
        doc.setFontSize(12); // Tamaño de la fuente para el título
        doc.text(
          `${i18n.global.t("Informe")} ${this.nomMes[this.mmConsulta]} de ${
            this.aaConsulta
          }`,
          150,
          50
        ); // Título en (x:  , y: ),
        doc.setFontSize(9);
        doc.text(
          `${i18n.global.t("Página")} ${pageNumber} ${i18n.global.t(
            "de"
          )} ${totalPages}`,
          doc.internal.pageSize.width / 2,
          doc.internal.pageSize.height - 30,
          { align: "center" }
        );
      };

      let totalPages = 1;
      doc.autoTable({
        head: [columns],
        body: rows,
        startY: 70, // Comienza la tabla después del header
        margin: { top: 70 }, // Margen superior para el header
        didDrawPage: () => {
          const pageNumber = doc.internal.getNumberOfPages();
          totalPages = pageNumber; // Actualizar número total de páginas
          addHeaderAndFooter(doc, pageNumber, totalPages);
        },
        styles: {
          cellPadding: 5, // Espaciado en las celdas
          fontSize: 9, // Tamaño de la fuente
        },
      });

      //doc.save("tabla_con_header_footer.pdf");

      const pdfBlob = doc.output("blob");

      // Crear una URL a partir del Blob
      const pdfURL = URL.createObjectURL(pdfBlob);
      console.log(pdfURL);
      // Abrir una nueva pestaña con el PDF
      window.open(pdfURL, "_blank");
      this.mostrarSpinner = false;
    },

    loadExportarPdf(resp) {
      this.showPanelExportar = resp;
      this.showPanelExportarExcel = false;
      this.showPanelAyuda = false;
    },
    loadModalExportarExcel(resp) {
      this.showPanelExportarExcel = resp;
      this.showPanelExportar = false;
      this.showPanelCalendario = false;
      this.showPanelAyuda = false;
    },
    loadPanelCalendario(resp) {
      //console.log("ayuda");
      this.showPanelCalendario = resp;
      this.showPanelExportar = false;
      this.showPanelExportarExcel = false;
      this.showPanelAyuda = false;
    },
    loadPanelAyuda(resp) {
      this.showPanelAyuda = resp;
      this.showPanelCalendario = false;
      this.showPanelExportar = false;
      this.showPanelExportarExcel = false;
    },
    loadAAMM(aamm) {
      this.aammConsulta = aamm;
    },
    async getFecCalendarExcel(f) {
      /* [ "01 10 2023",   "31 10 2023"]   */

      if (f[0] == "" || f[1] == "") return false;

      this.startDateExcel = this.convertirFormatoFecha(f[0]);
      this.endDateExcel = this.convertirFormatoFecha(f[1]);
    },
    async getFecCalendar(f) {
      /* f:= [ "01 10 2023",   "31 10 2023"]   */

      if (f[0] == "" || f[1] == "") return false;

      const startDate = (this.startDateExcel = this.convertirFormatoFecha(
        f[0]
      ));
      const endDate = (this.endDateExcel = this.convertirFormatoFecha(f[1]));

      this.fechaConsulta = f;

      this.mostrarSpinnerO2 = true;
      this.glosaDataTypeNatural = "";
      this.glosaDataTypeOxigenado = "";
      this.mostrarSpinner = true;
      const vista = "historial";
      this.frecuencia_minutos = this.$store.getters.diferenciaMinutos(
        startDate,
        endDate,
        this.propIdFaena
      );
      this.granularity = this.$store.getters.calculaPuntosGranularidad(
        this.frecuencia_minutos,
        vista
      );
      console.log('oscar',startDate, endDate)
      this.seriesFechas = this.granularity == "DAY"  
                          ? this.$store.getters.generaSerieFechas(startDate, endDate) 
                          : this.$store.getters.generaSerieHoras(startDate, endDate);

      Promise.allSettled([
        this.getSeriesDia(startDate, endDate, this.idO2Disuelto, "S"),
        this.getSeriesDia(startDate, endDate, this.idO2Disuelto, "N"),
        this.getSeriesDia(startDate, endDate, this.idOrp, "S"),
        this.getSeriesDia(startDate, endDate, this.idOrp, "N"),
      ])
        .then((results) => {
          const [natural, oxigenado, naturalOrp, ozonizado] = results.map((r) =>
            r.status === "fulfilled" ? r.value : []
          );

          this.seriesOxigeno = [[], natural, oxigenado]; // para botones opción 1, opción 2
          this.seriesMedicionesOxigenado = oxigenado;
          this.seriesMedicionesNatural = natural;

          this.seriesOrp = [[], naturalOrp, ozonizado]; // para botones opción 1, opción 2
          this.seriesMedicionesOrpOzonizado = ozonizado;
          this.seriesMedicionesOrpNatural = naturalOrp;
          this.mostrarSpinner = false;
        })
        .catch((error) => {
          console.error("Error en alguna de las promesas:", error);
        });
    },

    async getSeriesDia(startDate, endDate, parametroBuscado, es_faena_natural) {
      this.fechas = `${startDate} / ${endDate}`;

      const apiKey = this.$store.state.login.tokenLogin;
      const objFaenas = this.$store.state.faenas;

/*       let objFecha = this.$store.getters.fechaHoraActual(this.idFaena);
      const h = String(objFecha.getHours).padStart(2, "0");
      const min = String(objFecha.getMinutes).padStart(2, "0");
      const s = String(objFecha.getSeconds).padStart(2, "0");
 */
      try {
        // Filtrar faena y unidades correspondientes
        const objFaena = objFaenas.faenas.find(
          (faena) => faena.id === this.faena
        );
        if (!objFaena) throw new Error("Faena no encontrada");
        let jaulas;
        if (es_faena_natural == "S") {
          jaulas = objFaena.unidades.filter(
            (unidad) =>
              unidad.natural === es_faena_natural && unidad.tipo == "Plataforma"
          );
        } else {
          jaulas = objFaena.unidades.filter(
            (unidad) => unidad.natural === es_faena_natural
          );
        }

        //console.log("Jaulas seleccionadas:", jaulas);

        // Obtener datos de todas las jaulas
        const jaulaPromises = jaulas.map(async (jaula) => {
          const requestData = {
            idUnit: jaula.id,
            tsi: `${startDate} 00:00:00`,
            tsf: `${endDate} 23:59:59`, //${h}:${min}:${s}
            granularity: this.granularity,
          };

          try {
            const response = await axios.post(
              "/api/mon/getUnitData",
              requestData,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `${apiKey}`,
                },
              }
            );

            const sensors = response.data.payload.sensors || [];
            const arrayLecturas = sensors.flatMap((sensor) =>
              sensor.params.flatMap((param) => {
                if (
                  param.id === parametroBuscado &&
                  "injectionType" in param &&
                  param.injectionType == "dummy"
                ) {
                  if (es_faena_natural == "S") {
                    this.glosaDataTypeNatural =
                      "Natural: Se encontraron datos simulados";
                  } else {
                    this.glosaDataTypeOxigenado =
                      "Oxigenado: Se encontraron datos simulados";
                  }
                }
                return param.id === parametroBuscado
                  ? param.values.map((valor) => ({
                      value: valor.value,
                      ts: valor.ts,
                      injection: valor.injection,
                    }))
                  : [];
              })
            );
            let jdescrip = jaula.descripcion
              .replace("Jaula", i18n.global.t("jaula"))
              .replace("Plataforma", i18n.global.t("plataforma"));
            let descripcion =
              es_faena_natural == "S" ? `${jdescrip} (natural)` : jdescrip;
            return {
              idUnidad: jaula.id,
              nomUnidad: descripcion,
              arrayLecturas,
            };
          } catch (error) {
            console.error(`Error fetching data for jaula ${jaula.id}:`, error);
            return {
              idUnidad: jaula.id,
              nomUnidad: jaula.descripcion,
              arrayLecturas: [],
            };
          }
        });

        const arrayUnidades = await Promise.all(jaulaPromises);

        // Procesar datos de lecturas por unidad
        const seriesData = arrayUnidades.map((unidad) => {
          const datosDiarios = this.seriesFechas.map((fecha) => {
            let f;
            if (this.granularity == "DAY") {
              f = fecha;
              console.log("fecha", f);
            } else {
              f = fecha;
            }

            const lectura = unidad.arrayLecturas.find((item) => item.ts === f);

            // const ts = Date.parse(this.convertirFormatoFechaDMAEng(f));
            const ts = Date.parse(
              this.parseCustomDate(this.convertirFormatoFechaDMAEng(f))
            );

            const value = lectura ? Math.floor(lectura.value * 100) / 100 : 0;
            const injection = lectura ? lectura.injection : false;

            return [ts, value, injection];
          });

          return {
            name: unidad.nomUnidad,
            data: datosDiarios,
          };
        });

        // Asignar resultados finales

        if (parametroBuscado == this.idO2Disuelto) {
          this.mostrarSpinnerO2 = false;
        }

        return seriesData;
      } catch (error) {
        console.error("Error procesando faenas", error);
      }
    },
    parseCustomDate(str) {
      const [day, time, month, year] = str.split(" ");
      const months = {
        Jan: "01",
        Feb: "02",
        Mar: "03",
        Apr: "04",
        May: "05",
        Jun: "06",
        Jul: "07",
        Aug: "08",
        Sep: "09",
        Oct: "10",
        Nov: "11",
        Dec: "12",
      };
      const isoString = `${year}-${months[month]}-${day}T${time}`;
      return new Date(isoString); //  2025-06-04T17:00:00.000Z
    },

    convertirFormatoFechaDMA(fechaOriginal) {
      try {
        const partes = fechaOriginal.split("-");
        if (partes.length === 3) {
          const dia = partes[0];
          const mes = this.nomMes[Number(partes[1])];
          const año = partes[2];
          const nuevaFecha = `${año} ${mes} ${dia}`;
          return nuevaFecha;
        }
      } catch (error) {
        console.log(error);
      }
      return null;
    },
    convertirFormatoFechaDMAEng(fechaOriginal) {
      try {
        const partes = fechaOriginal.split("-");

        if (partes.length === 3) {
          const dia = partes[0];
          let paso = parseInt(partes[1]);
          const mes = this.nomMesEng[Number(paso)];
          const año = partes[2];
          const nuevaFecha = `${año} ${mes} ${dia}`;

          return nuevaFecha;
        }
      } catch (error) {
        console.log(error);
      }
      return null;
    },

    convertirFormatoFecha(fechaOriginal) {
      if (!fechaOriginal) return null;
      const [dia, mes, año] = fechaOriginal.split(" ");
      return dia && mes && año ? `${año}-${mes}-${dia}` : null;
    },

    generaSerieFechasDiario(startDate, endDate) {
      const dates = [];
      let current = startDate.startOf("day");
      const end = endDate.startOf("day");

      while (current <= end) {
        dates.push(current.toFormat("yyyy-MM-dd"));
        current = current.plus({ days: 1 });
      }

      return dates;
    },

    getArrayUnidades(es_faena_natural) {
      const objStoreFaenas = this.$store.state.faenas;
      const objFaena = objStoreFaenas.faenas.filter(
        (faena) => faena.id == this.idFaena
      );
      const objJaulas = objFaena[0].unidades.filter(
        (faena) => faena.natural == es_faena_natural
      );
      const nomFaena = objFaena[0].nombre;
      return {
        nomFaena,
        objJaulas,
      };
    },
    async exportarExcel() {
      this.mostrarSpinnerExcel = true;

      let startDate = this.startDateExcel; //  startDate = '2025-06-06'
      let endDate = this.endDateExcel;
      console.log("datetime", startDate);
      console.log("datetime", endDate);
      this.seriesFechas = this.$store.getters.generateDateRange(
        startDate,
        endDate,
        this.idFaena
      );
      let arrayNomJaulas = [];
      let headers = [];
      const { nomFaena, objJaulas } = this.getArrayUnidades("N");
      if (Array.isArray(objJaulas)) {
        arrayNomJaulas = objJaulas.map(
          (jaula) =>
            `IO ${jaula.descripcion
              .replace("Jaula", i18n.global.t("jaula"))
              .replace("Plataforma", i18n.global.t("plataforma"))} kg/día`
        );

        arrayNomJaulas.unshift(i18n.global.t("Fecha"));
        arrayNomJaulas.unshift("");
        arrayNomJaulas.push(i18n.global.t("Inyección kg"));
        arrayNomJaulas.push(i18n.global.t("Acumulado Ton"));

        arrayNomJaulas = [arrayNomJaulas];
        let cabh = arrayNomJaulas[0];

        for (let i = 0; i <= cabh.length; i++) {
          let w = i === 1 ? 12 : 14;
          headers.push({ header: cabh[i], width: w });
        }
        this.unidadesInjeccion = await this.getUnitGasInjection(
          startDate,
          endDate,
          "N"
        );
      } else {
        alert("no es un array");
      }
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(
        "Inyección O2 Centro " + nomFaena
      );
      worksheet.columns = headers;
      /* arrayNomJaulas.forEach((row) => {
        worksheet.addRow(row);
      }); */

      let indice = 0;
      let acumulado_diario_tons = 0;
      this.seriesFechas.forEach((fecha) => {
        let fec = fecha.split("-");
        let ddmm = fec[2] + "/" + fec[1] + "/" + fec[0];
        // itera objJaulas con todas las unidades
        // extrae de unidadesInjeccion, idUnidad +  indice actual, extrae valor
        // idUnidad: 101, inyection: ['115.56', 0, .. ]
        //console.log('oscar',objJaulas);
        //console.log("oscar", this.unidadesInjeccion);
        let row = [];
        let total = 0;
        let glosaDataType = "";
        objJaulas.forEach((jaula) => {
          let medicionUnidad = this.unidadesInjeccion.filter(
            (unidad) => unidad.idUnidad == jaula.id
          );

          if (Array.isArray(medicionUnidad)) {
            if (medicionUnidad[0].inyection !== null) {
              let med =
                typeof medicionUnidad[0].inyection[indice] !== "undefined"
                  ? medicionUnidad[0].inyection[indice]
                  : 0;
              let medf = parseFloat(med);
              medf = medf.toFixed(2).replace(".", ",");
              row.push(medf);
              if (medicionUnidad[0].glosaDataType[indice] !== "") {
                glosaDataType = true;
              }
              total += parseFloat(med);
            }
          }
        });

        acumulado_diario_tons += total;

        if (glosaDataType) {
          row.unshift(ddmm);
          row.unshift(i18n.global.t("Simulado"));
        } else {
          row.unshift(ddmm);
        }

        total = typeof total !== "undefined" ? total : 0;
        let totalf = parseFloat(total);
        totalf = totalf.toFixed(2).replace(".", ",");
        row.push(totalf);

        let tons =
          acumulado_diario_tons > 0
            ? parseFloat(acumulado_diario_tons / 1000)
            : 0;
        let tonsf = parseFloat(tons);
        tonsf = tonsf.toFixed(2).replace(".", ",");
        row.push(tonsf);

        const newRow = worksheet.addRow(row);
        newRow.eachCell((cell) => {
          cell.alignment = { horizontal: "right" };
          if (glosaDataType) {
            cell.font = { color: { argb: "9e9e9e" } };
          }
        });
        indice++;
      });

      arrayNomJaulas = objJaulas.map((jaula) => `OD ${jaula.descripcion} mg/L`);
      arrayNomJaulas.unshift(i18n.global.t("Fecha"));
      arrayNomJaulas.push(i18n.global.t("Inyección kg"));
      arrayNomJaulas.push(i18n.global.t("Acumulado Ton"));

      arrayNomJaulas = [arrayNomJaulas];
      let cabh = arrayNomJaulas[0];
      headers = [];
      for (let i = 0; i <= cabh.length; i++) {
        let w = i === 0 ? 12 : 14;
        headers.push({ header: cabh[i], width: w });
      }

      const worksheet2 = workbook.addWorksheet(
        "O2 Disuelto Centro " + nomFaena
      );
      worksheet2.columns = headers;
      /*  arrayNomJaulas.forEach((row) => {
         worksheet2.addRow(row);
       }); */
      indice = 0;

      this.unidadesOxigenoDisuelto = await this.getUnitOxigenoDisuelto(
        startDate,
        endDate,
        5,
        "N"
      );
      //this.fs2 = JSON.stringify(this.unidadesOxigenoDisuelto);
      acumulado_diario_tons = 0;
      this.seriesFechas.forEach((fecha) => {
        let fec = fecha.split("-");
        let ddmm = fec[2] + "/" + fec[1] + "/" + fec[0];

        let row = [];
        let medicion_jaula = 0;
        let total = 0;

        objJaulas.forEach((jaula) => {
          medicion_jaula = 0;

          let medicionUnidad = this.unidadesOxigenoDisuelto.filter(
            (unidad) => unidad.idUnidad == jaula.id
          );

          if (Array.isArray(medicionUnidad)) {
            if (medicionUnidad[0].mediciones !== null) {
              let mediciones = medicionUnidad[0].mediciones;
              const med = mediciones.find((item) => item.indice_dia === indice);

              //let med = medicionUnidad[0].mediciones[indice] !== null ? medicionUnidad[0].mediciones[indice] : 0;
              if (
                typeof med !== "undefined" &&
                typeof med.value !== "undefined"
              ) {
                medicion_jaula =
                  typeof med.value === "number" && !isNaN(med.value)
                    ? Math.floor(med.value * 100) / 100
                    : 0;
              }
            }
          }
          let medicionInjection = this.unidadesInjeccion.filter(
            (unidad) => unidad.idUnidad == jaula.id
          );
          if (Array.isArray(medicionInjection)) {
            if (medicionInjection[0].inyection !== null) {
              let med =
                medicionInjection[0].inyection[indice] !== null
                  ? medicionInjection[0].inyection[indice]
                  : 0;

              total += parseFloat(med);
            }
          }

          let medicion_jaula_f = "";
          if (medicion_jaula > 0) {
            medicion_jaula_f = medicion_jaula.toFixed(2).replace(".", ",");
          }

          row.push(medicion_jaula_f);
        });

        row.unshift(ddmm);

        total = total >= 0 ? total : 0;
        let totalf = "";
        if (total > 0) {
          totalf = total.toFixed(2).replace(".", ",");
        }
        row.push(totalf);
        acumulado_diario_tons += total;

        if (acumulado_diario_tons > 0) {
          let acum_tons = parseFloat(acumulado_diario_tons / 1000);
          let acum_tons_f = acum_tons.toFixed(4).replace(".", ",");
          row.push(acum_tons_f);
        }
        const newRow = worksheet2.addRow(row);
        newRow.eachCell((cell) => {
          cell.alignment = { horizontal: "right" };
        });
        indice++;
      });

      const blob = await workbook.xlsx.writeBuffer();
      const url = URL.createObjectURL(new Blob([blob]));
      const a = document.createElement("a");
      a.href = url;
      a.download = "Centro_" + nomFaena + "_O2_inyeccion_disuelto.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      this.mostrarSpinnerExcel = false;
    },
    loadMapa(id) {
      console.log("LOAD MAPA", id);
      this.showModalMapa = true;
      this.idFaenaSeleccionada = id;
    },
    closeModal() {
      this.showModalMapa = false;
    },
    loadMultiplesUnidades() {
      this.showPickMonth = true;
    },
    computed: {
      ...mapGetters(["user", "token"]),
    },
  },
};
</script>
